<div class="c-widget--info-new" [ngClass]="customClass">
  <div class="c-widget--info-new--block -dark -first">
    <span class="title">
      <p500-ui-icon class="p500-ui-icon-reporting-star icon -purple"></p500-ui-icon>
      <ng-container i18n="@@common.basic_information">Basic Information</ng-container>
    </span>

    <div class="c-widget--info-new--cards -basic">
      <div class="c-widget--info-new--card -white -first-basic-card">
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.name">Name</span>: </span>
          <gtd-ui-field-default-string-whitespace-or-empty
            [data]="data.name"
            [length]="18"
          ></gtd-ui-field-default-string-whitespace-or-empty>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.activity">Activity</span>: </span>
          <gtd-ui-field-user-status [data]="data.status"></gtd-ui-field-user-status>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@affiliate.tracking_domain">Tracking Domain</span>: </span>
          <gtd-ui-field-default-string-or-default [data]="data.affiliate_offer_tracking_domain?.tracking_domain.name">
          </gtd-ui-field-default-string-or-default>
        </div>
      </div>

      <div class="c-widget--info-new--card -white -second-basic-card">
        <div class="c-widget--info-new--row">
          <span>Telegram ID:</span>
          <gtd-ui-field-default-string-whitespace-or-empty
            [data]="data.telegram_id"
            [length]="10"
          ></gtd-ui-field-default-string-whitespace-or-empty>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.advertiser">Advertisers</span>: </span>
        </div>
        <div class="c-widget--info-new--row">
          <ng-container *ngIf="data.advertisers?.length; else emptyTmpl">
            <p500-ui-many-items
              [data]="data.advertisers"
              i18n-title="@@common.all_advertiser"
              title="All Advertisers"
              [tmpl]="tmpl"
              [previewTmpl]="previewTmpl"
            >
            </p500-ui-many-items>
            <ng-template let-data="data" #previewTmpl>
              {{ data.name }}
              <span class="text-color text-color--gray">&nbsp;/&nbsp;{{ data.id }}</span
              >:&nbsp;{{ data.external_id }}
            </ng-template>
            <ng-template let-data="data" #tmpl>
              <span class="font-headline-5">
                {{ data.name
                }}<span class="text-color text-color--gray">
                  &nbsp;/&nbsp;
                  {{ data.id }}</span
                >:&nbsp;{{ data.external_id }}
              </span>
            </ng-template>
          </ng-container>
        </div>
      </div>

      <div class="c-widget--info-new--card -white -third-basic-card">
        <div class="c-widget--info-new--row">
          <span>2FA:</span>
          <gtd-ui-field-default-boolean [data]="data.otp"></gtd-ui-field-default-boolean>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@affiliate.fee">Affiliate Fee</span>: </span>
          <gtd-ui-field-default-boolean [data]="data.enable_shared_fees"></gtd-ui-field-default-boolean>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@affiliate.only_qualified_postbacks">Only Qualified Postbacks</span>: </span>
          <gtd-ui-field-default-boolean [data]="data.only_qualified_postback"></gtd-ui-field-default-boolean>
        </div>
      </div>
    </div>
  </div>

  <div class="c-widget--info-new--block -white -second">
    <span class="title">
      <p500-ui-icon name="other-list" class="h-icon-reporting-list icon"></p500-ui-icon>
      <ng-container i18n="@@common.additional">Additional</ng-container>
    </span>

    <div class="c-widget--info-new--cards -info">
      <div class="c-widget--info-new--card -first-info-card">
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.first_name">First Name</span>: </span>
          <gtd-ui-field-default-protected
            [data]="data.first_name"
            [fixedLength]="6"
            [whitespaceLength]="length"
            [copyToClipboard]="true"
            [stringWithCopyFieldLength]="15"
            [stringWithCopyClassName]="'d-flex'"
          ></gtd-ui-field-default-protected>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.last_name">Last Name</span>: </span>
          <gtd-ui-field-default-protected
            [data]="data.last_name"
            [fixedLength]="6"
            [whitespaceLength]="length"
            [copyToClipboard]="true"
            [stringWithCopyFieldLength]="15"
            [stringWithCopyClassName]="'d-flex'"
          ></gtd-ui-field-default-protected>
        </div>
        <div class="c-widget--info-new--row">
          <span>Email:</span>
          <gtd-ui-field-default-protected
            [data]="data.email"
            [fixedLength]="6"
            [whitespaceLength]="length"
            [copyToClipboard]="true"
            [stringWithCopyFieldLength]="15"
            [stringWithCopyClassName]="'d-flex'"
          ></gtd-ui-field-default-protected>
        </div>
      </div>

      <div class="c-widget--info-new--card -second-info-card">
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.birthday">Birthday</span>: </span>
          <gtd-ui-field-default-protected [data]="data.birthday" [fixedLength]="6" [whitespaceLength]="10"></gtd-ui-field-default-protected>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.phone">Phone</span>: </span>
          <gtd-ui-field-default-protected
            [data]="data.phone"
            [fixedLength]="6"
            [whitespaceLength]="length"
            [copyToClipboard]="true"
            [stringWithCopyClassName]="'d-flex'"
          ></gtd-ui-field-default-protected>
        </div>
        <div class="c-widget--info-new--row">
          <span>Skype:</span>
          <gtd-ui-field-default-protected
            [data]="data.skype"
            [fixedLength]="6"
            [whitespaceLength]="length"
            [copyToClipboard]="true"
            [stringWithCopyFieldLength]="15"
            [stringWithCopyClassName]="'d-flex'"
          ></gtd-ui-field-default-protected>
        </div>
      </div>

      <div class="c-widget--info-new--card -third-info-card">
        <div class="c-widget--info-new--row">
          <span>Telegram:</span>
          <gtd-ui-field-default-protected
            [data]="data.telegram"
            [fixedLength]="6"
            [whitespaceLength]="length"
            [copyToClipboard]="true"
            [stringWithCopyFieldLength]="15"
            [stringWithCopyClassName]="'d-flex'"
          ></gtd-ui-field-default-protected>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.description">Description</span>: </span>
        </div>
        <div class="c-widget--info-new--row">
          <gtd-ui-field-default-string-whitespace-or-empty [data]="data.description"> </gtd-ui-field-default-string-whitespace-or-empty>
        </div>
      </div>
    </div>
  </div>

  <div class="c-widget--info-new--block -white -third">
    <span class="title">
      <p500-ui-icon class="p500-ui-icon-timestamps icon"></p500-ui-icon>
      <ng-container i18n="@@common.timestamps">Timestamps</ng-container>
    </span>

    <div class="c-widget--info-new--cards">
      <div class="c-widget--info-new--card">
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.created_at">Created At</span>: </span>
          <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
        </div>
        <div class="c-widget--info-new--row">
          <span> <span i18n="@@common.updated_at">Updated At</span>: </span>
          <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyTmpl>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
